'use client';

import { useEffect } from 'react';

/**
 * Scopes the `widget-embed` body styling (overflow: hidden, see globals.css) to ONLY this
 * embeddable iframe route. Applying it on the root layout's <body> would also lock scrolling
 * on the /widgets catalog and preview pages, hiding the embed-code UI below the 560px preview.
 * Toggling the class here keeps those pages scrollable while the live iframe stays clipped.
 */
export default function WidgetEmbedBody() {
    useEffect(() => {
        document.body.classList.add('widget-embed');
        return () => document.body.classList.remove('widget-embed');
    }, []);

    return null;
}
